import { Type } from 'vue-models'

export default class NumberField extends Type {
  constructor (value, key) {
    super(value, key)
    const val = this.getValue(value)
    if (val !== null && val !== undefined) this.set(val)
    return this
  }
  out () {
    if (this.value !== null && this.value !== undefined) {
      return Number(this.value).toString()
    }
    return undefined
  }
}



// WEBPACK FOOTER //
// ./src/models/types/NumberField.js